import React, {useState, useEffect, useMemo} from "react"
import './designSection.scss'

const PopUp = ({ element, inView, display }) => {

    const [active, toggle] = useState(false)

    useEffect(() => {
        if (inView && display) {
            const show = setTimeout(() => {
                toggle(true)
            }, 1200);
            const hide = setTimeout(() => {
                toggle(false)
            }, 10000);
            return () => {
                clearTimeout(show)
                clearTimeout(hide)
            }
        } else toggle(false)
    }, [inView, display])

    const style = useMemo(() => {
        if (element.background.presets === "image") {
            return {
                backgroundImage: `url(${element.background.popupImage.mediaDetails.sizes[3].sourceUrl})`,
                backgroundSize: "cover",
                backgroundPosition: 'center',
            }
        } else if (element.background.presets === "custom") {
            return {background: element.background.custom}
        } else return {background: element.background.presets || "var(--white)"}
    }, [element])

    if (element.text || element.background.popupImage) {
        return (
            <div className={active ? "pop-up active" : "pop-up"} style={style}>
                <button className="close" onClick={() => toggle(false)} />
                <div className="content" dangerouslySetInnerHTML={{ __html: element.text }}>
                </div>
            </div>
        )
    } else return <div />
}

export default PopUp
